var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h3", { staticClass: "modal-title" }, [_vm._v(" FORMULA ")]),
      _vm._v(" "),
      _c(
        "b-form-group",
        { class: { "error-input": _vm.$v.data_formula.title.$error } },
        [
          _c("label", [_vm._v(" Formula Title ")]),
          _vm._v(" "),
          _c("j-input", {
            attrs: { "max-length": 255, placeholder: "Formula Title" },
            model: {
              value: _vm.$v.data_formula.title.$model,
              callback: function($$v) {
                _vm.$set(_vm.$v.data_formula.title, "$model", $$v)
              },
              expression: "$v.data_formula.title.$model"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-form-group",
        { class: { "error-input": _vm.$v.data_formula.form.$error } },
        [
          _c("label", [_vm._v(" Select Form ")]),
          _vm._v(" "),
          _c("j-single-select", {
            attrs: {
              "load-options": _vm.loadOptionsForm,
              "is-async": true,
              "cache-option": false,
              placeholder: "Choose Form",
              "value-format": "object",
              label: "name"
            },
            model: {
              value: _vm.$v.data_formula.form.$model,
              callback: function($$v) {
                _vm.$set(_vm.$v.data_formula.form, "$model", $$v)
              },
              expression: "$v.data_formula.form.$model"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.formulaId
        ? _c("b-form-group", [
            _c("label", [_vm._v(" Formula ")]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "card-field-container" },
              [
                _vm._l(_vm.data_variable, function(variable, index) {
                  return _c(
                    "div",
                    { key: variable.id, staticClass: "card-field-container" },
                    [
                      _c("label", [
                        _vm._v(" Variable " + _vm._s(index + 1) + " ")
                      ]),
                      _vm._v(" "),
                      _vm.data_variable.length > 1
                        ? _c("i", {
                            staticClass: "fa fa-times close-button",
                            on: {
                              click: function($event) {
                                _vm.deleteVariable(index)
                              }
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      variable.isDisabled
                        ? _c(
                            "b-row",
                            [
                              _c("b-col", { attrs: { cols: "12" } }, [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      variable.source.id === 2
                                        ? "(" + variable.source_value.text + ")"
                                        : variable.source_value
                                    ) +
                                    "\n            " +
                                    _vm._s(variable.operand.text) +
                                    "\n            " +
                                    _vm._s(
                                      variable.righthand === 2
                                        ? variable.righthand_value.text
                                        : variable.righthand_value
                                    ) +
                                    "\n          "
                                )
                              ])
                            ],
                            1
                          )
                        : _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { attrs: { cols: "4" } },
                                [
                                  _c("j-single-select", {
                                    attrs: {
                                      options: _vm.sourceOptions(index),
                                      disabled: variable.isDisabled,
                                      "value-format": "object",
                                      placeholder: "Choose Source"
                                    },
                                    on: {
                                      input: function($event) {
                                        _vm.openModal(index, "source")
                                      }
                                    },
                                    model: {
                                      value: variable.source,
                                      callback: function($$v) {
                                        _vm.$set(variable, "source", $$v)
                                      },
                                      expression: "variable.source"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                { attrs: { cols: "4" } },
                                [
                                  !variable.modeSelectOperand
                                    ? _c(
                                        "button",
                                        {
                                          class: _vm.buttonStyle(
                                            variable.source_value &&
                                              variable.source
                                          ),
                                          attrs: {
                                            disabled:
                                              !variable.source_value ||
                                              !variable.source
                                          },
                                          on: {
                                            click: function($event) {
                                              _vm.addOperand(index)
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n              + Add Operation\n            "
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  variable.modeSelectOperand
                                    ? _c("j-single-select", {
                                        attrs: {
                                          options: _vm.list_operand,
                                          disabled: variable.isDisabled,
                                          "value-format": "object",
                                          placeholder: "Choose Operand"
                                        },
                                        model: {
                                          value: variable.operand,
                                          callback: function($$v) {
                                            _vm.$set(variable, "operand", $$v)
                                          },
                                          expression: "variable.operand"
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                { attrs: { cols: "4" } },
                                [
                                  !variable.modeSelectRighthand &&
                                  variable.operand
                                    ? _c(
                                        "button",
                                        {
                                          class: _vm.buttonStyle(
                                            variable.operand
                                          ),
                                          attrs: {
                                            disabled: !variable.operand
                                          },
                                          on: {
                                            click: function($event) {
                                              _vm.addRighthand(index)
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n              + Add Source\n            "
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  variable.modeSelectRighthand
                                    ? _c("j-single-select", {
                                        attrs: {
                                          options: _vm.sourceOptions(index),
                                          disabled: variable.isDisabled,
                                          "value-format": "object",
                                          placeholder: "Choose Source"
                                        },
                                        on: {
                                          input: function($event) {
                                            _vm.openModal(index, "righthand")
                                          }
                                        },
                                        model: {
                                          value: variable.righthand,
                                          callback: function($$v) {
                                            _vm.$set(variable, "righthand", $$v)
                                          },
                                          expression: "variable.righthand"
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              )
                            ],
                            1
                          ),
                      _vm._v(" "),
                      variable.isDisabled
                        ? _c(
                            "button",
                            {
                              staticClass: "btn btn-add-additional-info",
                              on: {
                                click: function($event) {
                                  _vm.editVariable(index)
                                }
                              }
                            },
                            [_vm._v("\n          Edit Variable\n        ")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.variableOn(index)
                        ? _c(
                            "b-button",
                            {
                              staticClass: "btn blue",
                              on: {
                                click: function($event) {
                                  _vm.saveVariable(index)
                                }
                              }
                            },
                            [_vm._v("\n          Add\n        ")]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                }),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-add-additional-info",
                    on: { click: _vm.addVariable }
                  },
                  [_vm._v("\n        + Add Variable\n      ")]
                )
              ],
              2
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c("b-col", [
            _c(
              "div",
              { staticClass: "float-to-right" },
              [
                _c(
                  "b-button",
                  {
                    staticClass: "btn gray m__r--5",
                    on: { click: _vm.closeFormula }
                  },
                  [_vm._v("\n          Close\n        ")]
                ),
                _vm._v(" "),
                !_vm.formulaId
                  ? _c(
                      "b-button",
                      {
                        staticClass: "btn blue",
                        on: { click: _vm.saveFormula }
                      },
                      [_vm._v("\n          Next\n        ")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.formulaId && !_vm.modeEdit
                  ? _c(
                      "b-button",
                      {
                        staticClass: "btn blue",
                        on: { click: _vm.finishFormula }
                      },
                      [_vm._v("\n          Finish\n        ")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.formulaId && _vm.modeEdit
                  ? _c(
                      "b-button",
                      {
                        staticClass: "btn blue",
                        on: { click: _vm.finishFormula }
                      },
                      [_vm._v("\n          Update\n        ")]
                    )
                  : _vm._e()
              ],
              1
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "modalSelectVariableSource",
          staticClass: "mod-form",
          attrs: { centered: "" }
        },
        [
          _c(
            "b-form-group",
            [
              _c("label", [_vm._v(" Select Source ")]),
              _vm._v(" "),
              _vm.modeValue === "source"
                ? _c("j-single-select", {
                    attrs: {
                      options: _vm.sourceOptions(_vm.selectedIndex),
                      "value-format": "object",
                      placeholder: "Choose Source"
                    },
                    model: {
                      value: _vm.data_variable[_vm.selectedIndex].source,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.data_variable[_vm.selectedIndex],
                          "source",
                          $$v
                        )
                      },
                      expression: "data_variable[selectedIndex].source"
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.modeValue === "righthand"
                ? _c("j-single-select", {
                    attrs: {
                      options: _vm.sourceOptions(_vm.selectedIndex),
                      "value-format": "object",
                      placeholder: "Choose Source"
                    },
                    model: {
                      value: _vm.data_variable[_vm.selectedIndex].righthand,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.data_variable[_vm.selectedIndex],
                          "righthand",
                          $$v
                        )
                      },
                      expression: "data_variable[selectedIndex].righthand"
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-form-group",
            [
              _c("label", [_vm._v(" Value ")]),
              _vm._v(" "),
              _vm.modeValue === "source" && !_vm.isResult
                ? _c("j-input", {
                    attrs: { type: "number", placeholder: "Input Value" },
                    model: {
                      value: _vm.data_variable[_vm.selectedIndex].source_value,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.data_variable[_vm.selectedIndex],
                          "source_value",
                          $$v
                        )
                      },
                      expression: "data_variable[selectedIndex].source_value"
                    }
                  })
                : _vm.modeValue === "source" && _vm.isResult
                ? _c("j-single-select", {
                    attrs: {
                      options: _vm.list_result,
                      "value-format": "object",
                      placeholder: "Choose Result"
                    },
                    model: {
                      value: _vm.data_variable[_vm.selectedIndex].source_value,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.data_variable[_vm.selectedIndex],
                          "source_value",
                          $$v
                        )
                      },
                      expression: "data_variable[selectedIndex].source_value"
                    }
                  })
                : _vm.modeValue === "righthand" && !_vm.isResult
                ? _c("j-input", {
                    attrs: { type: "number", placeholder: "Input Value" },
                    model: {
                      value:
                        _vm.data_variable[_vm.selectedIndex].righthand_value,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.data_variable[_vm.selectedIndex],
                          "righthand_value",
                          $$v
                        )
                      },
                      expression: "data_variable[selectedIndex].righthand_value"
                    }
                  })
                : _vm.modeValue === "righthand" && _vm.isResult
                ? _c("j-single-select", {
                    attrs: {
                      options: _vm.list_result,
                      "value-format": "object",
                      placeholder: "Choose Result"
                    },
                    model: {
                      value:
                        _vm.data_variable[_vm.selectedIndex].righthand_value,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.data_variable[_vm.selectedIndex],
                          "righthand_value",
                          $$v
                        )
                      },
                      expression: "data_variable[selectedIndex].righthand_value"
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c("b-col", [
                _c(
                  "div",
                  { staticClass: "float-to-right" },
                  [
                    _c(
                      "b-button",
                      {
                        staticClass: "btn gray m__r--5",
                        on: { click: _vm.closeSelectSource }
                      },
                      [_vm._v("\n            Close\n          ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "b-button",
                      {
                        staticClass: "btn blue",
                        on: { click: _vm.closeSelectSource }
                      },
                      [_vm._v("\n            Save\n          ")]
                    )
                  ],
                  1
                )
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5fbcd4f1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5fbcd4f1","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/pages/pages-component/jFormulaSetup.vue
// module id = null
// module chunks = 